import Comunicado, {
  FinderComunicados,
  RetornoComunicado,
} from 'Interface/Comunicados';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

const tag = 'Comunicados';

const url = '/comunicados';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarComunicados: construtor.query<
        FinderComunicados,
        Parametros | void
      >({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.comunicados
            ? [
                ...resultado.comunicados.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarComunicado: construtor.query<
        RetornoComunicado,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarComunicado: construtor.mutation<Comunicado, Partial<Comunicado>>(
        {
          query: (dados) => ({
            url: url,
            method: 'POST',
            body: formData(dados, 'POST'),
          }),
          invalidatesTags: (resultado, erro) =>
            !erro ? [{ type: tag, id: 'LISTA' }] : [],
        }
      ),
      editarComunicado: construtor.mutation<
        Comunicado,
        Partial<Comunicado> & Pick<Comunicado, 'id'> & { options?: Parametros }
      >({
        query: ({ id, options, ...dados }) => ({
          url: `${url}/${id}?${paramsParaString({ options })}`,
          method: 'POST',
          body: formData(dados, 'PUT'),
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
      removerComunicado: construtor.mutation<
        Comunicado,
        Partial<Comunicado> & Pick<Comunicado, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'POST',
          body: formData(dados, 'DELETE'),
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarComunicadosQuery,
  useRecuperarComunicadoQuery,
  useAdicionarComunicadoMutation,
  useEditarComunicadoMutation,
  useRemoverComunicadoMutation,
} = apiExtendida;
